<!--
 * @Description  : 合同模板维护 -- 旧
 * @Author       : 王帅
 * @Date         : 2024-07-18 10:10:40
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-14 15:01:12
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\es-contract-template-maintain\index.vue
-->
<template>
	<div class="w-page-main">
		<!-- 顶部搜索栏 -->
		<div class="w-page-header">
			<div class="left-text overflow-hidden">
				<el-button type="primary" size="small" @click="addClick('addLocalTemplate')">新增本地模板</el-button>
			</div>
			<div class="btnGroups ml10">
				<el-button type="primary" icon="el-icon-refresh" size="mini" circle @click="onRefresh"></el-button>
			</div>
		</div>

		<!-- 下方内容 -->
		<div class="w-page-container">
			<templateList ref="listTable" @on-reset="onReset"></templateList>
		</div>
	</div>
</template>

<script>
import searchArea from 'components/searchArea/searchArea'
import templateList from './components/table'
import { mapState } from 'vuex'
export default {
	components: { searchArea, templateList },
	props: {},
	data() {
		return {
			searchForm: {
				sname: ''
			},
			btnLoading: false,
			dialogObj: {
				title: '新增字典组',
				visible: false,
				width: '650px',
				type: 'add'
			}
		}
	},
	created() {},
	methods: {
		// 新增字典组
		addClick(type) {
			if (type === 'addLocalTemplate') {
				this.$refs.listTable.doClick('', type)
			}
		},

		// 确认搜索
		onSearch() {
			this.$refs.listTable.getPageTableList(this.searchForm)
		},
		// 点击刷新
		onRefresh() {
			this.onReset()
			this.onSearch()
		},

		// 点击重置
		onReset() {
			this.searchForm.sname = ''
		}
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		})
	}
}
</script>

<style scoped lang="less"></style>
